"use strict";

angular.module("core")
.factory("PatternService", function() {
    return {
        email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        emailAsUsername: /^(([\w+-_]+(\.[\w+-_]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        phone: /^[ \d\-]+$/,
        phoneDigitsAndChars: /^([^0-9]*[0-9]){7,}[^0-9]*$/,
        username: /^[\w.@+-]+$/,
        decimalNumber: /^[0-9]{1,7}(\.[0-9]{1,2})?$/,
        precisePrice: /^[0-9]+(\.[0-9]{1,5})?$/,
        preciseWeightGreaterThanZero: /^0*[1-9][0-9]*(\.[0-9]{1,3})?$|^0+\.(?=[0-9]{1,3}$)([0-9]*[1-9][0-9]*)/,
        positivePreciseWeight: /^[0-9]+(\.[0-9]{1,3})?$/,
        negativePrice: /^-?([0-9]){1,8}(\.[0-9]{1,2})?$/,
        orderedQuantity: /^[0-9]+(\.[0-9]{1,2})?$/,
        checkNumber: /^0?[0-9]{5,7}$/,
        digits: /^\d+$/,
        numberGreaterThanZero: /^[1-9]\d*$/,
        PONumber: /^([a-zA-Z0-9\-]{1,22})$/,
        urlStart: /^https?:\/\/.+$/
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/pattern/pattern.factory.js
// module id = 459
// module chunks = 0